import axios from '../../function/axiosInstance'
import extract from '../../function/extract'

export const updateCompanyDetails = async ({
  onboardedOn,
  pepperOrganization,
  companyId
}: {
  onboardedOn: string
  pepperOrganization: string
  companyId: string
}): Promise<ApiResponse> => {
  try {
    const response = await axios.put(`/companies/${companyId}`, {
      pepper_organization: pepperOrganization,
      onboarded_on_pepper_organization_since: onboardedOn
    })
    return extract.data(response)
  } catch (error) {
    return extract.error(error)
  }
}
